/** Textos do chat ZaroAI. */
const pt = {
    "zaro.launcher": "Falar com o ZaroAI",
    "zaro.name": "ZaroAI",
    "zaro.status": "Assistente da ZRS · responde em segundos",
    "zaro.newChat": "Nova conversa",
    "zaro.close": "Fechar chat",
    "zaro.welcome":
        "Olá! Eu sou o **Zaro**, o assistente da ZRS 🤖\nRespondo a dúvidas sobre o servidor, VIPs, kits e Rust — mas primeiro entra com a tua conta Discord.",
    "zaro.welcomeUser":
        "Olá, **{name}**! Eu sou o **Zaro**, o assistente da ZRS 🤖\nPergunta-me sobre o servidor, VIPs e kits, ou qualquer dúvida de Rust — raides, crafting, monumentos, eletricidade…",
    "zaro.loginCta": "Entrar com Discord para falar com o Zaro",
    "zaro.placeholderLocked": "Entra com Discord para conversar",
    "zaro.error.login": "A tua sessão expirou. Entra outra vez com Discord para continuar.",
    "zaro.suggestionsLabel": "Sugestões",
    "zaro.suggestions": [
        "Qual VIP compensa mais?",
        "O que vem no kit Apoiador?",
        "Quanto custa raidar uma parede de pedra?",
        "Quando é o próximo wipe?",
    ],
    "zaro.placeholder": "Escreve a tua pergunta…",
    "zaro.send": "Enviar",
    "zaro.typing": "O Zaro está a escrever…",
    "zaro.itemsLabel": "Itens mencionados",
    "zaro.disclaimer":
        "O Zaro é uma IA e pode errar. As conversas são guardadas para melhorar o suporte — não partilhes senhas nem dados pessoais.",
    "zaro.error.rate": "Estás a enviar mensagens muito depressa. Tenta outra vez daqui a {seconds}s.",
    "zaro.error.busy": "O Zaro está com muita procura agora. Tenta outra vez daqui a pouco.",
    "zaro.error.offline": "O Zaro está a descansar neste momento. Para ajuda, abre um ticket no Discord.",
    "zaro.error.full": "Esta conversa ficou muito longa. Começa uma nova conversa para continuar.",
    "zaro.error.generic": "Não consegui responder agora. Verifica a ligação e tenta outra vez.",
    "zaro.error.banned": "A tua conta está bloqueada no ZaroAI. Se achas que é engano, abre um ticket no Discord.",
    "zaro.retry": "Tentar outra vez",
    "zaro.charsLeft": "{n} caracteres restantes",
};
const en = {
    "zaro.launcher": "Chat with ZaroAI",
    "zaro.name": "ZaroAI",
    "zaro.status": "ZRS assistant · replies in seconds",
    "zaro.newChat": "New chat",
    "zaro.close": "Close chat",
    "zaro.welcome":
        "Hi! I'm **Zaro**, the ZRS assistant 🤖\nI answer questions about the server, VIPs, kits and Rust — but first sign in with your Discord account.",
    "zaro.welcomeUser":
        "Hi, **{name}**! I'm **Zaro**, the ZRS assistant 🤖\nAsk me about the server, VIPs and kits, or any Rust question — raids, crafting, monuments, electricity…",
    "zaro.loginCta": "Sign in with Discord to chat with Zaro",
    "zaro.placeholderLocked": "Sign in with Discord to chat",
    "zaro.error.login": "Your session expired. Sign in with Discord again to continue.",
    "zaro.suggestionsLabel": "Suggestions",
    "zaro.suggestions": [
        "Which VIP is the best value?",
        "What's in the Supporter kit?",
        "How much does it cost to raid a stone wall?",
        "When is the next wipe?",
    ],
    "zaro.placeholder": "Type your question…",
    "zaro.send": "Send",
    "zaro.typing": "Zaro is typing…",
    "zaro.itemsLabel": "Items mentioned",
    "zaro.disclaimer":
        "Zaro is an AI and can make mistakes. Chats are stored to improve support — don't share passwords or personal data.",
    "zaro.error.rate": "You're sending messages too fast. Try again in {seconds}s.",
    "zaro.error.busy": "Zaro is very busy right now. Please try again shortly.",
    "zaro.error.offline": "Zaro is resting right now. For help, open a ticket on Discord.",
    "zaro.error.full": "This chat got too long. Start a new chat to continue.",
    "zaro.error.generic": "I couldn't reply right now. Check your connection and try again.",
    "zaro.error.banned": "Your account is blocked from ZaroAI. If you think this is a mistake, open a Discord ticket.",
    "zaro.retry": "Try again",
    "zaro.charsLeft": "{n} characters left",
};

export default { pt, en };
